import React, { useEffect } from 'react';
import { styled } from '@mui/material/styles';
import { Stack } from '@mui/joy';
import {
  useDashStore,
  useWellnessLogs,
  // useEducation
} from 'src/hooks';
import { Header, Select, Alert, Button, PatientSummary } from 'src/components';
import { WellnessLogsTable } from './WellnessLogsTable';

const Container = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.offWhite.main,
  height: '100dvh',
  display: 'flex',
}));

export const WellnessLogs = (props) => {
  // const [didCreateEducation, setDidCreateEducation] = useState(false);
  const {
    selectedUser,
    setSelectedUser,
    userOptions,
    appUsers,
    showAlert,
    groups,
    dismissAlert,
    viewingProfile,
    setViewingProfile,
  } = useDashStore();
  const allUsers = selectedUser.id === 'All Users';

  const { allLogs, mostRecentLogs, getWellnessLogsForUsers, getMostRecentLogsByUser, clearLogs } =
    useWellnessLogs();

  // const { createEducation } = useEducation();

  useEffect(() => {
    if (userOptions.length > 1) {
      let options = userOptions.slice(1, userOptions.length);
      getWellnessLogsForUsers(options);
    } else {
      // Group has no participants with a username - don't keep showing the previous group's logs
      clearLogs();
    }
    // if (!didCreateEducation) {
    //   console.log('created education');
    //   createEducation();
    // setDidCreateEducation(true);
    // }
  }, [userOptions]);

  const setNewUser = (val) => {
    const newUserObject = userOptions.find((i) => i.username === val);
    setSelectedUser(newUserObject);
  };

  return (
    <Container {...props}>
      <Header title={selectedUser ? `Wellness Logs (${selectedUser.username})` : 'Wellness Logs'}>
        {!allUsers && (
          <Button
            onClick={() => setViewingProfile(!viewingProfile)}
            sx={{ width: '15ch' }}>
            {viewingProfile ? 'View Logs' : 'View Profile'}
          </Button>
        )}
        <Select
          id="user-select"
          options={userOptions.map((i) => i.username)}
          value={selectedUser.username}
          setValue={setNewUser}
          filterable
          clearValue="All Users"
          sx={{ minWidth: '200px' }}
        />
      </Header>
      <WellnessLogsTable />
      <PatientSummary />
    </Container>
  );
};
